import CoreLibrary from "../../../../../core/helpers/CoreLibrary";

export const Schema = {
    extends: CoreLibrary,
    props: {
        tableId: {
            type: String,
            required: true,
        },
        modalId: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            preloader: false,
            tabInit: 0,
            currentTabIndex: 0,
            currentTabSubmitEvent: () => { },
            currentTabCancelEvent: () => { },
            dataMaster: null,
            dataCarry: {},
            skippedTabIndexes: [],
            tabs: [],
            enableSubmit: false,
            formWizardId: this.modalId,
            modalTitle: 'Product Approval',
            modalSize: 'fullscreen',
            modalAlignment: 'center',
        };
    },
    computed: {
        canBack() {
            return this.currentTabIndex > 0;
        },
        currentTab() {
            return this.tabs[this.currentTabIndex];
        },
    },
    methods: {
        resetCurrentTabEvent() {
            this.currentTabSubmitEvent = null;
            this.currentTabCancelEvent = null;
        },
        currentComponentName() {
            if (this.currentTabIndex >= 0 && this.currentTabIndex < this.tabs.length) {
                this.currentTab.onInit?.(this.currentTab);
                this.$emit(
                    "selectedComponentName",
                    this.currentTab.component
                );
            }
        },
        selectedTab(value) {
            this.currentTabIndex = value;
            this.enableSubmit = false;
            this.currentComponentName();
        },
        formattedIDR(value) {
            // Format the value as IDR
            return new Intl.NumberFormat("id-ID", {
                style: "currency",
                currency: "IDR",
                minimumFractionDigits: 0,
            }).format(value);
        },
        async waitUntilReady(callback) {
            while (this.preloader) {
                await new Promise(r => setTimeout(r, 0));
            }
            callback?.();
        },
        submit() {
            if (!this.enableSubmit) return;
            this.enableSubmit = false;
            this.currentTabSubmitEvent?.();
            this.waitUntilReady(() => {
                if (this.currentTabIndex < this.tabs.length - 1) {
                    this.currentTabIndex++;
                    if (this.skippedTabIndexes.includes(this.currentTabIndex)) this.currentTabIndex++;
                }
                this.currentComponentName();
            });
        },
        cancel() {
            if (this.currentTabIndex > 0) {
                this.currentTabIndex--;
                if (this.skippedTabIndexes.includes(this.currentTabIndex)) this.currentTabIndex--;
            }
            this.currentTabCancelEvent?.();
            this.currentComponentName();
        },
        mapDataCarryToOverview() {
            const data = {};
            // Add customer information
            if (this.dataCarry['lead']) {
                data.lead = this.mapLeadToOverview(this.dataCarry['lead']);
            }
            // Add product information
            if (this.dataCarry['product']) {
                data.product = this.mapProductToOverview(this.dataCarry['product']);
            }
            // Add packages information
            if (this.dataCarry['packages']) {
                data.product = {
                    ...data.product,
                    list_packages: this.mapPackagesToOverview(this.dataCarry['packages']),
                };
            }
            // Add class information
            if (this.dataCarry['class']) {
                data.class = this.mapClassToOverview(this.dataCarry['class']);
            }
            // Add semester information
            if (this.dataCarry['academic_calendar']) {
                data.academic_calendar = this.mapSemesterToOverview(this.dataCarry['academic_calendar']);
            }
            this.dataCarry['overview'] = data;
        },
        mapLeadToOverview(data) {
            return {
                label: 'Sudent',
                id: {
                    value: data.id,
                },
                name: {
                    label: 'Name',
                    value: data.full_name ?? data.name,
                },
                clc_id_number: {
                    label: 'CLC ID',
                    value: data.clc_id_number ?? data.lead_id_number,
                },
            };
        },
        mapProductToOverview(data) {
            return {
                label: 'Product',
                id: {
                    value: data.id,
                },
                name: {
                    label: 'Name',
                    value: data.name,
                },
                description: {
                    label: 'Description',
                    value: data.description,
                },
                product_category_id: {
                    value: data.product_category.id,
                },
                product_category: {
                    label: 'Category',
                    value: data.product_category.name,
                },
                product_level_id: {
                    value: data.product_level.product_level_id,
                },
                product_level: {
                    label: 'Level',
                    value: data.product_level.product_level_desc,
                },
                teaching_type_id: {
                    value: data.teaching_type.teaching_type_id,
                },
                teaching_type: {
                    label: 'Teaching Type',
                    value: data.teaching_type.teaching_type_desc,
                },
                price: {
                    label: 'Price',
                    value: this.formattedIDR(data.price),
                },
                payment_status_id: {
                    value: data.payment_status.id,
                },
                payment_status: {
                    label: 'Payment Status',
                    value: data.payment_status.payment_status_desc,
                },
            };
        },
        mapPackagesToOverview(data) {
            return {
                label: 'List Packages',
                value: data ? [{
                    id: {
                        value: data.id,
                    },
                    package_name: {
                        label: 'Package 1',
                        value: data.package_name,
                    },
                    course_list_packages: {
                        label: 'Available Course',
                        value: data.course_list_packages?.map((clp) => ({
                            id: {
                                value: clp.course.id,
                            },
                            course: {
                                label: 'Course Name',
                                value: clp.course.course_name,
                            },
                            course_date_clc_start: {
                                label: 'CLC Date Start',
                                value: clp.course.course_date_clc_start,
                            },
                            course_date_clc_end: {
                                label: 'CLC Date End',
                                value: clp.course.course_date_clc_end,
                            },
                        })) ?? []
                    },
                }] : [],
            };
        },
        mapClassToOverview(data) {
            return {
                label: 'Class',
                id: {
                    value: data.id
                },
                name: {
                    label: 'Name',
                    value: data.name
                },
            };
        },
        mapSemesterToOverview(data) {
            return {
                label: 'Semester',
                id: {
                    value: data.id,
                },
                academic_calendar_name: {
                    label: 'Name',
                    value: data.academic_calendar_name,
                },
            };
        },
        mapOverviewToJson(dataRaw) {
            if (Array.isArray(dataRaw)) {
                return dataRaw.map(item => this.mapOverviewToJson(item));
            } else if (dataRaw.value && Array.isArray(dataRaw.value)) {
                return dataRaw.value.map(item => this.mapOverviewToJson(item));
            } else if (dataRaw && typeof dataRaw === "object") {
                if (dataRaw.value && typeof dataRaw.value !== 'object' && !Array.isArray(dataRaw.value)) {
                    return dataRaw.value;
                }
                const result = {};
                for (const [key, val] of Object.entries(dataRaw)) {
                    if (key !== "label") {
                        result[key] = this.mapOverviewToJson(val);
                    }
                }
                return result;
            }
            return dataRaw;
        },
    },
};